import { render, staticRenderFns } from "./ParentListForm.vue?vue&type=template&id=4f93c846"
import script from "./ParentListForm.vue?vue&type=script&lang=js"
export * from "./ParentListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports